module.exports = __webpack_public_path__ + "img/taketomi_13.41350495.jpg";